<mat-toolbar mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
    <b>Purchase Order Issue Date</b>
</mat-toolbar>

<mat-divider></mat-divider>

<mat-dialog-content fxLayout="column" [formGroup]="formGroup">
    <lgd-date-picker controlName="issueDate" label="Issue Date" telemetry="Edit-IssueDate-Purchasing">
    </lgd-date-picker>

    <lgd-checkbox controlName="useIssueDate" label="Use Requisition Issue Date" aria-label="Select-RequisitionDate-IssueDate-Purchasing">
    </lgd-checkbox>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button color="primary" (click)="close()" telemetry="Submission-Cancel-PurchaseOrder-Purchasing">
        Cancel
    </button>
    <button mat-button color="primary" (click)="create()" [disabled]="formGroup.invalid" telemetry="Submission-Approve-PurchaseOrder-Purchasing">
        Create PO
    </button>
</mat-dialog-actions>